// extracted by mini-css-extract-plugin
module.exports = {"content":"Layout_content__Ni2t0","desktop":"Layout_desktop__2B9Ne","phone":"Layout_phone__GO_DO"};